import React from 'react'
import { Link } from 'react-router-dom'
import firebase from 'firebase'

import context from '../context'

const logoutUser = logout => () => {
  firebase.auth().signOut()
  logout()
}

const navOnLogIn = (logout) => {
    return (
        <React.Fragment>
            <li>
                <Link to="/adddata" className="nav-link btn">Add Data</Link>
            </li>

            <li>
                <a href="/" className="nav-link btn" onClick={logoutUser(logout)}>Logout</a>
            </li>
        </React.Fragment>
    )
}

const navOnNoUser = () => {
    return (
        <React.Fragment>
            <li className="nav-item">
                <Link to='/login' className="nav-link btn">Login</Link>
            </li>

            <li className="nav-item">
                <Link to='/register' className="nav-link btn">Register</Link>
            </li>
        </React.Fragment>
    )
}

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container flex-grow-1">
            <Link className="navbar-brand" to="/">Rahasia Saya</Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <Link to='/' className="nav-link btn">Home</Link>
                    </li>

                    <context.Consumer>
                        {
                            data => {
                                return (
                                    data.user ? navOnLogIn(data.logout) : navOnNoUser()
                                )
                            }
                        }
                    </context.Consumer>
                </ul>
            </div>
        </div>
    </nav>
  )
}

export default Navbar